module.exports = __webpack_public_path__ + "d6a1dc2f544451975e07510c141658fc.MP3";